export const resx = {
    "de": {
        "views": {
            "PortalController": {
                "GeneralCancel": "Abbrechen",
                "GeneralSaveAndCopy": "Speichern und kopieren",
                "GeneralDelete": "Löschen",
                "GeneralExport": "Exportieren",
                "GeneralLogout": "Ausloggen",
                "GeneralSave": "Speichern",
                "GeneralSearch": "Suchen...",
                "GeneralShow": "Ansehen",
                "NavApiVersion": "API Versionen",
                "NavBuyRequest": "Selfsignups",
                "NavCancellations": "Stornierungen",
                "NavCatalog": "Katalog",
                "NavCategory": "Kategorien",
                "NavDashboard": "Dashboard",
                "NavHangfireDashboard": "Hangfire - Dashboard",
                "NavDocument": "Dokumente",
                "NavFeedback": "Feedback",
                "NavFulfillmentGroup": "Erfüllungsgruppen",
                "NavItem": "Artikel",
                "NavLocation": "Standorte",
                "NavOffer": "Angebote",
                "NavOfferCategory": "Angebotskategorien",
                "NavOfferSchedule": "Planung",
                "NavOptionGroup": "Optionsgruppen",
                "NavOrder": "Bestellungen",
                "NavPayment": "Zahlungen",
                "NavSecPay": "Bezahlen",
                "NavProductionSite": "Produktionsorte",
                "NavRefund": "Rückerstattungen",
                "NavReportCategory": "Berichtskategorien",
                "NavRoom": "Räume",
                "NavSecLocation": "Standort",
                "NavSecOffer": "Angebot",
                "NavSecOrder": "Bestellung",
                "NavSecReport": "Berichte",
                "NavSecSystem": "System",
                "NavStatus": "Status",
                "NavStock": "Bestand",
                "NavSubscription": "Abonnements",
                "NavSupportRequest": "Support-Anfragen",
                "NavTable": "Tische",
                "NavTask": "Aufgaben",
                "NavTransaction": "Transaktionen",
                "NavUseCase": "Anwendungen",
                "NavUser": "Nutzer",
                "NavUtil": "PSP",
                "NavVisits": "Besuche",
                "NotificationNoEntries": "Keine neuen Benachrichtigungen",
                "NotificationTitle": "Benachrichtigungen",
                "NewPaymentMethod": "Neue Zahlungsmethode",
                "NavVoucher": "Gutscheine",
                "PortalTitle": "Tastier Portal",
                "NavDiscounts": "Rabatte"
            },
            "Combinations": {
                "MaximumOccupancy": "Maximale Belegung",
                "NewCombination": "Neue Kombination",
                "NoCombinationsAdded": "Noch keine Kombinationen angelegt...",
                "SortOrder": "Reihenfolge",
                "PreferredMinimumOccupancy": "Bevorzugte Mindestbelegung",
                "Tables": "Tische",
                "TableCombinationInUseError": "Diese Kombination wird verwendet und kann nicht gelöscht werden. Deaktivieren Sie sie, um eine zukünftige Verwendung zu verhindern.",
                "ViewTitle": "Kombinationen",
            },
            "DiscountEdit": {
                "Accounting": "Buchhaltung",
                "AllItems": "Alle Artikel",
                "AllApplications": "Alle Anwendungen",
                "AllOfferCategories": "Alle Angebotskategorien",
                "AllOffers": "Alle Angebote",
                "Applicability": "Anwendbarkeit",
                "Applications": "Anwendungen",
                "ApplyOncePerOrderOrBill": "Nur einmal pro Bestellung / Rechnung anwenden",
                "Cancelled": "Storniert",
                "Created": "Erstellt",
                "Discount": "Rabatt",
                "DiscountCode": "Rabattcode",
                "EndUsers": "Endnutzer",
                "Items": "Artikel",
                "LeadOperators": "Leitende Betreiber",
                "Name": "Bezeichnung",
                "OfferCategories": "Angebotskategorien",
                "Offers": "Angebote",
                "OpenValue": "Offener Betrag",
                "Operators": "Betreiber",
                "Order": "Reihenfolge",
                "Type": "Art",
                "UserGroups": "Nutzergruppen",
                "Value": "Wert",
                "ViewTitle": "Rabatt bearbeiten",
                "EditDiscount": "Rabatt bearbeiten",
                "QrCode": "QR-Code",
                "Mode": "Modus",
                "StartDate": "Beginn",
                "EndDate": "Ende",
                "InternalName": "Interne Bezeichnung",
                "CustomCode": "Benutzerdefinierter Code",
                "CustomCodeAlreadyTaken": "Code existiert bereits, versuchen Sie einen anderen.",
                "CustomCodeInvalidLength": "Der Code muss zwischen 4 und 24 Zeichen lang sein.",
                "CustomCodeInvalidFormat": "Der Code darf nur Großbuchstaben und Ziffern enthalten.",
                "CancellationBtn": "Stornieren"
            },
            "Discounts": {
                "NewDiscount": "Neuer Rabatt",
                "ViewTitle": "Rabatte"
            },
            "Index": {
                "Allocations": "Besuche",
                "DailyAllocations": "Besuche (24 Stunden)",
                "HotlineText": "+41 76 784 44 68",
                "HotlineTitle": "<a class=\"kt-link\" href=\"callto:+41767844468\">Hotline / Support</a>",
                "LocationText": "1. Erstellen Sie einen Standort",
                "LocationTitle": "Standorte",
                "MonthlyTurnover": "Umsatz (30 Tage)",
                "NewActivities": "Neueste Aktivitäten",
                "NewSignups": "Registrierungen (30 Tage)",
                "NewUsers": "Registrierungen",
                "OrdersThisYear": "Bestellungen",
                "PaymentText": "Zahlungen",
                "PaymentTitle": "Transaktionen",
                "RoomText": "2. Erstellen Sie mind. 1 Raum und fügen Sie mind. 1 Service hinzu.<br />3. Erstellen Sie im Menü \"Tische\" Ihre Tische / Orte und den / die QR-Code(s)",
                "RoomTitle": "Räume",
                "SystemText": "Technische Auswertungen",
                "SystemTitle": "System",
                "UserText": "Nutzer und Zugangsberechtigungen",
                "UserTitle": "Nutzer ({0} online)",
                "ViewTitle": "Dashboard",
                "WelcomeFaq": "FAQ",
                "WelcomeHelp": "Hilfe",
                "WelcomeText": "Der Link unten gibt Antworten auf häufig gestellte Fragen. Ihre Frage wird dort nicht beantwortet, Ihnen fehlt eine Funktion, es gibt einen Fehler, etwas ist unklar? Wir freuen uns über Ihr Feedback an <a href=\"mailto:marketing@tastier.ch\">marketing@tastier.ch</a>. In dringenden Fällen ist unser Telefon-Support für Sie da.<br /><br /><a href=\"https://www.tastier.ch/contractpartners-de/\" class=\"kt-link\" target=\"_blank\">Wissenswertes für Vertragspartner</a>",
                "WelcomeTitle": "Willkommen im Tastier Portal",
                "YearlyOrders": "Bestellungen {0}"
            },
            "TableParties": {
                "PreferredMinimumSize": "Bevorzugte Mindestgrösse",
                "MaximumSize": "Maximale Grösse",
                "Party": "Gruppe",
            },
            "OverwriteStandardServiceDurationPerShiftForm": {
                "Overwrite": "Überschreibung"
            }
        }
    },
    "en": {
        "views": {
            "PortalController": {
                "GeneralCancel": "Cancel",
                "GeneralSaveAndCopy": "Save and copy",
                "GeneralDelete": "Delete",
                "GeneralExport": "Export",
                "GeneralLogout": "Log out",
                "GeneralSave": "Save",
                "GeneralSearch": "Search...",
                "GeneralShow": "View",
                "NavApiVersion": "API Versions",
                "NavBuyRequest": "Selfsignups",
                "NavCancellations": "Cancellations",
                "NavCatalog": "Catalogue",
                "NavCategory": "Categories",
                "NavDashboard": "Dashboard",
                "NavHangfireDashboard": "Hangfire - Dashboard",
                "NavDocument": "Documents",
                "NavFeedback": "Feedback",
                "NavFulfillmentGroup": "Fulfillment Groups",
                "NavItem": "Items",
                "NavLocation": "Locations",
                "NavOffer": "Offers",
                "NavOfferCategory": "Offer Categories",
                "NavOfferSchedule": "Planning",
                "NavOptionGroup": "Option Groups",
                "NavOrder": "Orders",
                "NavPayment": "Payments",
                "NavSecPay": "Pay",
                "NavProductionSite": "Production Sites",
                "NavRefund": "Refunds",
                "NavReportCategory": "Reporting Categories",
                "NavRoom": "Rooms",
                "NavSecLocation": "Location",
                "NavSecOffer": "Offer",
                "NavSecOrder": "Order",
                "NavSecReport": "Reports",
                "NavSecSystem": "System",
                "NavStatus": "Status",
                "NavStock": "Stock",
                "NavSubscription": "Subscriptions",
                "NavSupportRequest": "Support Requests",
                "NavTable": "Tables",
                "NavTask": "Tasks",
                "NavTransaction": "Transactions",
                "NavUseCase": "Applications",
                "NavUser": "Users",
                "NavUtil": "PSP",
                "NavVisits": "Visits",
                "NotificationNoEntries": "No new notifications",
                "NotificationTitle": "Notifications",
                "NewPaymentMethod": "New payment method",
                "NavVoucher": "Vouchers",
                "PortalTitle": "Tastier Portal",
                "NavDiscounts": "Discounts"
            },
            "Combinations": {
                "MaximumOccupancy": "Maximum occupancy",
                "NewCombination": "New Combination",
                "NoCombinationsAdded": "No combinations added yet..",
                "SortOrder": "Sort order",
                "PreferredMinimumOccupancy": "Preferred minimum occupancy",
                "Tables": "Tables",
                "TableCombinationInUseError": "This combination is in use and can’t be deleted. Disable it to prevent future use.",
                "ViewTitle": "Combinations",
            },
            "DiscountEdit": {
                "Accounting": "Accounting",
                "AllItems": "All items",
                "AllApplications": "All applications",
                "AllOfferCategories": "All offer categories",
                "AllOffers": "All offers",
                "Applicability": "Applicability",
                "Applications": "Applications",
                "ApplyOncePerOrderOrBill": "Apply only once per order/bill",
                "Cancelled": "Cancelled",
                "Created": "Created",
                "Discount": "Discount",
                "DiscountCode": "Discount code",
                "EndUsers": "End users",
                "Items": "Items",
                "LeadOperators": "Lead Operators",
                "Name": "Name",
                "OfferCategories": "Offer categories",
                "Offers": "Offers",
                "OpenValue": "Open value",
                "Operators": "Operators",
                "Order": "Order",
                "Type": "Type",
                "UserGroups": "User Groups",
                "Value": "Value",
                "ViewTitle": "Edit discount",
                "EditDiscount": "Edit discount",
                "QrCode": "QR Code",
                "Mode": "Mode",
                "StartDate": "Start",
                "EndDate": "End",
                "InternalName": "Internal name",
                "CustomCode": "Custom code",
                "CustomCodeAlreadyTaken": "Code already exists, try a different one.",
                "CustomCodeInvalidLength": "Code must be 4-24 characters long.",
                "CustomCodeInvalidFormat": "Code must be uppercase and alphanumeric.",
                "CancellationBtn": "Cancel"
            },
            "Discounts": {
                "NewDiscount": "New discount",
                "ViewTitle": "Discounts"
            },
            "Index": {
                "Allocations": "Visits",
                "DailyAllocations": "Visits (24 hours)",
                "HotlineText": "+41 76 784 44 68",
                "HotlineTitle": "<a class=\"kt-link\" href=\"callto:+41767844468\">Hotline / Support</a>",
                "LocationText": "1. Create a location",
                "LocationTitle": "Locations",
                "MonthlyTurnover": "Sales (30 days)",
                "NewActivities": "Recent activities",
                "NewSignups": "Signups (30 days)",
                "NewUsers": "signups",
                "OrdersThisYear": "Orders",
                "PaymentText": "Payments",
                "PaymentTitle": "Transactions",
                "RoomText": "2. Create at least 1 room and add at least 1 service.<br />3. Create your tables / places and the QR code(s) in the \"Tables\" menu",
                "RoomTitle": "Rooms",
                "SystemText": "Technical statistics",
                "SystemTitle": "System",
                "UserText": "Users and access permissions",
                "UserTitle": "Users ({0} online)",
                "ViewTitle": "Dashboard",
                "WelcomeFaq": "FAQ",
                "WelcomeHelp": "Help",
                "WelcomeText": "The link below provides answers to frequently asked questions. Your question is not answered there, you are missing a feature, there is an error, something is unclear? We appreciate your feedback at <a href=\"mailto:marketing@tastier.ch\">marketing@tastier.ch</a>. In urgent cases, our telephone support is there for you.<br /><br /><a href=\"https://www.tastier.ch/contractpartners/\" class=\"kt-link\" target=\"_blank\">Things to know for contract partners</a>",
                "WelcomeTitle": "Welcome to the Tastier Portal",
                "YearlyOrders": "Orders {0}"
            },
            "TableParties": {
                "PreferredMinimumSize": "Preferred minimum size",
                "MaximumSize": "Maximum size",
                "Party": "Party",
            },
            "OverwriteStandardServiceDurationPerShiftForm": {
                "Overwrite": "Overwrite"
            }
        }
    },
    "fr": {
        "views": {
            "PortalController": {
                "GeneralCancel": "Annuler",
                "GeneralSaveAndCopy": "Sauvegarder et copier",
                "GeneralDelete": "Supprimer",
                "GeneralExport": "Exporter",
                "GeneralLogout": "Se déconnecter",
                "GeneralSave": "Sauvegarder",
                "GeneralSearch": "Rechercher...",
                "GeneralShow": "Voir",
                "NavApiVersion": "Versions de l'API",
                "NavBuyRequest": "Selfsignups",
                "NavCancellations": "Annulations",
                "NavCatalog": "Catalogue",
                "NavCategory": "Catégories",
                "NavDashboard": "Dashboard",
                "NavHangfireDashboard": "Hangfire - Dashboard",
                "NavDocument": "Documents",
                "NavFeedback": "Feedback",
                "NavFulfillmentGroup": "Groupe d'Exécution",
                "NavItem": "Articles",
                "NavLocation": "Sites",
                "NavOffer": "Offres",
                "NavOfferCategory": "Catégories d'Offres",
                "NavOfferSchedule": "Planification",
                "NavOptionGroup": "Groupes d'Options",
                "NavOrder": "Commandes",
                "NavPayment": "Paiements",
                "NavSecPay": "Payer",
                "NavProductionSite": "Lieux de Production",
                "NavRefund": "Remboursements",
                "NavReportCategory": "Catégories de Rapports",
                "NavRoom": "Salles",
                "NavSecLocation": "Site",
                "NavSecOffer": "Offre",
                "NavSecOrder": "Commande",
                "NavSecReport": "Rapports",
                "NavSecSystem": "Système",
                "NavStatus": "Statut",
                "NavStock": "Stock",
                "NavSubscription": "Abonnements",
                "NavSupportRequest": "Demandes de Support",
                "NavTable": "Tables",
                "NavTask": "Tâches",
                "NavTransaction": "Transactions",
                "NavUseCase": "Applications",
                "NavUser": "Utilisateurs",
                "NavUtil": "PSP",
                "NavVisits": "Visites",
                "NotificationNoEntries": "Pas de nouvelles notifications",
                "NotificationTitle": "Notifications",
                "NewPaymentMethod": "Nouveau mode de paiement",
                "NavVoucher": "Bons",
                "PortalTitle": "Portail Tastier",
                "NavDiscounts": "Remises"
            },
            "Combinations": {
                "MaximumOccupancy": "Occupation maximale",
                "NewCombination": "Nouvelle combinaison",
                "NoCombinationsAdded": "Aucune combinaison créée ...",
                "SortOrder": "Ordre",
                "PreferredMinimumOccupancy": "Occupation minimale préférée",
                "Tables": "Tables",
                "TableCombinationInUseError": "Cette combinaison est utilisée et ne peut pas être supprimée. Désactivez-la pour éviter une utilisation future.",
                "ViewTitle": "Combinaisons",
            },
            "DiscountEdit": {
                "Accounting": "Comptabilité",
                "AllItems": "Tous les articles",
                "AllApplications": "Toutes les applications",
                "AllOfferCategories": "Toutes les catégories d'offre",
                "AllOffers": "Toutes les offres",
                "Applicability": "Applicabilité",
                "Applications": "Applications",
                "ApplyOncePerOrderOrBill": "A n’appliquer qu'une seule fois par commande / note",
                "Cancelled": "Annulé",
                "Created": "Créé",
                "Discount": "Remise",
                "DiscountCode": "Code de remise",
                "EndUsers": "Utilisateurs finaux",
                "Items": "Articles",
                "LeadOperators": "Opérateurs principaux",
                "Name": "Dénomination",
                "OfferCategories": "Catégories d’offre",
                "Offers": "Offres",
                "OpenValue": "Montant libre",
                "Operators": "Opérateurs",
                "Order": "Ordre",
                "Type": "Type",
                "UserGroups": "Groupes d'utilisateurs",
                "Value": "Valeur",
                "ViewTitle": "Editer la remise",
                "EditDiscount": "Modifier la remise",
                "QrCode": "QR code",
                "Mode": "Mode",
                "StartDate": "Début",
                "EndDate": "Fin",
                "InternalName": "Désignation interne",
                "CustomCode": "Code personnalisé",
                "CustomCodeAlreadyTaken": "Le code existe déjà, essayez-en un autre.",
                "CustomCodeInvalidLength": "Le code doit contenir entre 4 et 24 caractères.",
                "CustomCodeInvalidFormat": "Le code doit être en majuscules et composé uniquement de lettres et de chiffres.",
                "CancellationBtn": "Annuler"
            },
            "Discounts": {
                "NewDiscount": "Nouvelle remise",
                "ViewTitle": "Remises"
            },
            "Index": {
                "Allocations": "Visites",
                "DailyAllocations": "Visites (24 heures)",
                "HotlineText": "+41 76 784 44 68",
                "HotlineTitle": "<a class=\"kt-link\" href=\"callto:+41767844468\">Hotline / Support</a>",
                "LocationText": "1. Créez un site",
                "LocationTitle": "Sites",
                "MonthlyTurnover": "Ventes (30 jours)",
                "NewActivities": "Activités récentes",
                "NewSignups": "Inscriptions (30 jours)",
                "NewUsers": "inscriptions",
                "OrdersThisYear": "Commandes",
                "PaymentText": "Paiements",
                "PaymentTitle": "Transactions",
                "RoomText": "2. Créez au moins 1 salle et ajoutez au moins 1 service.<br />3. Dans le menu \"Tables\", créez vos tables / lieux et le / les QR code(s)",
                "RoomTitle": "Salles",
                "SystemText": "Statistiques techniques",
                "SystemTitle": "Système",
                "UserText": "Utilisateurs et droits d'accès",
                "UserTitle": "Utilisateurs ({0} online)",
                "ViewTitle": "Dashboard",
                "WelcomeFaq": "FAQ",
                "WelcomeHelp": "Aide",
                "WelcomeText": "Le lien ci-dessous donne des réponses aux questions fréquemment posées. Votre question n'y trouve pas de réponse, il vous manque une fonction, il y a une erreur, quelque chose n'est pas clair ? N'hésitez pas à nous faire part de vos commentaires à <a href=\"mailto:marketing@tastier.ch\">marketing@tastier.ch</a>. En cas d'urgence, notre assistance téléphonique est à votre disposition.<br /><br /><a href=\"https://www.tastier.ch/contractpartners-fr/\" class=\"kt-link\" target=\"_blank\">Ce qu'il faut savoir pour les partenaires contractuels</a>",
                "WelcomeTitle": "Bienvenue sur le Portail Tastier",
                "YearlyOrders": "Commandes {0}"
            },
            "TableParties": {
                "PreferredMinimumSize": "Taille minimale préférée",
                "MaximumSize": "Taille maximale",
                "Party": "Groupe",
            },
            "OverwriteStandardServiceDurationPerShiftForm": {
                "Overwrite": "Écrasement"
            }
        }
    },
    "it": {
        "views": {
            "PortalController": {
                "GeneralCancel": "Cancellare",
                "GeneralSaveAndCopy": "Salvare e copiare",
                "GeneralDelete": "Cancellare",
                "GeneralExport": "Esportare",
                "GeneralLogout": "Disconnettere",
                "GeneralSave": "Salvare",
                "GeneralSearch": "Cercare...",
                "GeneralShow": "Vedere",
                "NavApiVersion": "Versioni API",
                "NavBuyRequest": "Selfsignups",
                "NavCancellations": "Cancellazioni",
                "NavCatalog": "Catalogo",
                "NavCategory": "Categorie",
                "NavDashboard": "Dashboard",
                "NavHangfireDashboard": "Hangfire - Dashboard",
                "NavDocument": "Documenti",
                "NavFeedback": "Feedback",
                "NavFulfillmentGroup": "Gruppi di Adempimento",
                "NavItem": "Articoli",
                "NavLocation": "Ubicazioni",
                "NavOffer": "Offerte",
                "NavOfferCategory": "Categorie di Offerta",
                "NavOfferSchedule": "Pianificazione",
                "NavOptionGroup": "Gruppi di Opzioni",
                "NavOrder": "Ordini",
                "NavPayment": "Pagamenti",
                "NavSecPay": "Pagare",
                "NavProductionSite": "Siti di Produzione",
                "NavRefund": "Rimborsi",
                "NavReportCategory": "Categorie di Rapporti",
                "NavRoom": "Stanze",
                "NavSecLocation": "Ubicazione",
                "NavSecOffer": "Offerta",
                "NavSecOrder": "Ordine",
                "NavSecReport": "Rapporti",
                "NavSecSystem": "Sistema",
                "NavStatus": "Stato",
                "NavStock": "Scorte",
                "NavSubscription": "Abbonamenti",
                "NavSupportRequest": "Richieste di Supporto",
                "NavTable": "Tavoli",
                "NavTask": "Attività",
                "NavTransaction": "Transazioni",
                "NavUseCase": "Applicazioni",
                "NavUser": "Utenti",
                "NavUtil": "PSP",
                "NavVisits": "Visite",
                "NotificationNoEntries": "Nessuna nuova notifica",
                "NotificationTitle": "Notifiche",
                "NewPaymentMethod": "Nuovo metodo di pagamento",
                "NavVoucher": "Buoni",
                "PortalTitle": "Portale Tastier",
                "NavDiscounts": "Sconti"
            },
            "Combinations": {
                "MaximumOccupancy": "Occupazione massima",
                "NewCombination": "Nuova combinazione",
                "NoCombinationsAdded": "Nessuna combinazione creata ...",
                "SortOrder": "Ordine",
                "PreferredMinimumOccupancy": "Occupazione minima preferita ",
                "Tables": "Tavoli",
                "TableCombinationInUseError": "Questa combinazione è in uso e non può essere eliminata. Disattivala per impedirne l’uso futuro.",
                "ViewTitle": "Combinazioni",
            },
            "DiscountEdit": {
                "Accounting": "Contabilità",
                "AllItems": "Tutti gli articoli",
                "AllApplications": "Tutte le applicazioni",
                "AllOfferCategories": "Tutte le categorie di offerta",
                "AllOffers": "Tutte le offerte",
                "Applicability": "Applicabilità",
                "Applications": "Applicazioni",
                "ApplyOncePerOrderOrBill": "Applicare solo una volta per ogni ordine / conto",
                "Cancelled": "Annullato",
                "Created": "Creato",
                "Discount": "Sconto",
                "DiscountCode": "Codice sconto",
                "EndUsers": "Utenti finali",
                "Items": "Articoli",
                "LeadOperators": "Operatori leader",
                "Name": "Denominazione",
                "OfferCategories": "Categorie di offerta",
                "Offers": "Offerte",
                "OpenValue": "Importo libero",
                "Operators": "Operatori",
                "Order": "Sequenza",
                "Type": "Tipo",
                "UserGroups": "Gruppi di utenti",
                "Value": "Valore",
                "ViewTitle": "Modificare lo sconto",
                "EditDiscount": "Modificare sconto",
                "QrCode": "Codice QR",
                "Mode": "Modalità",
                "StartDate": "Inizio",
                "EndDate": "Fine",
                "InternalName": "Designazione interna",
                "CustomCode": "Codice personalizzato",
                "CustomCodeAlreadyTaken": "Il codice esiste già, provatene uno diverso.",
                "CustomCodeInvalidLength": "Il codice deve contenere da 4 a 24 caratteri.",
                "CustomCodeInvalidFormat": "Il codice deve essere in maiuscolo e contenere solo lettere e numeri.",
                "CancellationBtn": "Annullare"
            },
            "Discounts": {
                "NewDiscount": "Nuovo sconto",
                "ViewTitle": "Sconti"
            },
            "Index": {
                "Allocations": "Visite",
                "DailyAllocations": "Visite (24 ore)",
                "HotlineText": "+41 76 784 44 68",
                "HotlineTitle": "<a class=\"kt-link\" href=\"callto:+41767844468\">Hotline / Support</a>",
                "LocationText": "1. Crea una ubicazione",
                "LocationTitle": "Ubicazioni",
                "MonthlyTurnover": "Vendite (30 giorni)",
                "NewActivities": "Attività recenti",
                "NewSignups": "Registrazioni (30 giorni)",
                "NewUsers": "registrazioni",
                "OrdersThisYear": "Ordini",
                "PaymentText": "Pagamenti",
                "PaymentTitle": "Transazioni",
                "RoomText": "2. Crea almeno 1 stanza e aggiungi almeno 1 servizio.<br />3. Crea i tuoi tavoli / luoghi e il/i codice/i QR nel menu \"Tavoli\"",
                "RoomTitle": "Stanze",
                "SystemText": "Statistiche tecniche",
                "SystemTitle": "Sistema",
                "UserText": "Utenti e diritti di accesso",
                "UserTitle": "Utenti ({0} online)",
                "ViewTitle": "Dashboard",
                "WelcomeFaq": "FAQ",
                "WelcomeHelp": "Aiuto",
                "WelcomeText": "Il link qui sotto fornisce le risposte alle domande più frequenti. La tua domanda non trova risposta lì, ti manca una funzione, c'è un errore, qualcosa non è chiaro? Diamo il benvenuto ai vostri commenti a <a href=\"mailto:marketing@tastier.ch\">marketing@tastier.ch</a>. In casi urgenti, il nostro supporto telefonico è a vostra disposizione.<br /><br /><a href=\"https://www.tastier.ch/contractpartners-it/\" class=\"kt-link\" target=\"_blank\">Cose da sapere per i Partner Contrattuali</a>",
                "WelcomeTitle": "Benvenuto nel portale Tastier",
                "YearlyOrders": "Ordini {0}"
            },
            "TableParties": {
                "PreferredMinimumSize": "Dimensione minima preferita",
                "MaximumSize": "Dimensione massima ",
                "Party": "Gruppo",
            },
            "OverwriteStandardServiceDurationPerShiftForm": {
                "Overwrite": "Sovrascrittura"
            }
        }
    }
}